import appConfig from "src/config/env";
import { COMMOM_STATUS, EXPORT_TYPE, orderStatusFormatted, PRINT_SIZE } from "src/constant";
import useWarehouseTransferExport from "src/hooks/warehouse-transfer/useWarehouseTranferExport";
import useOrderPrint from "src/hooks/orders/useOrderPrint";
import useProcessLogDetail from "src/hooks/process-log/useProcessLogDetail";
import { useEffect, useState } from "react";
import { enqueueSnackbar } from "notistack";

const usePreviewPdf = () => {
  const { trigger: printWT } = useWarehouseTransferExport();
  const { trigger: printOrder } = useOrderPrint();
  const [logId, setLogId] = useState(null);
  const { mutate } = useProcessLogDetail(logId);

  const handlePrintWarehouseTransfer = async (item, transferFileType = orderStatusFormatted.Exported) => {
    try {
      const res = await printWT({
        body: {
          warehouseTransferIds: [item?.contextId],
          transferFileType: transferFileType,
        },
      });
      if (res?.success) {
        setLogId(res?.data?.input?.processLog);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handlePrintOrder = async (item, outputFile = EXPORT_TYPE.WarehouseExport) => {
    try {
      const res = await printOrder({
        body: {
          orderIds: [item?.contextId || item?._id],
          pageSize: PRINT_SIZE.a6,
          warehouse: item?.warehouse?._id,
          outputFiles: [outputFile],
        },
      });
      if (res?.success) {
        setLogId(res?.data?.input?.processLog);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const timeOut = setInterval(async () => {
      try {
        const res = await mutate();
        if (res?.success) {
          if (res.data.status === COMMOM_STATUS.done) {
            if (Array.isArray(res.data?.urls)) {
              res.data.urls.forEach((v) => {
                window.open(`${appConfig.API_FILE}/${v}`, "_blank");
              });
            }
            clearInterval(timeOut);
          }

          if (res.data.status === COMMOM_STATUS.error) {
            enqueueSnackbar("Không xuất được đơn", { variant: "error" });
            clearInterval(timeOut);
          }
        }
      } catch (err) {
        clearInterval(timeOut);
      }
    }, 1000);
    return () => clearInterval(timeOut);
  }, [logId, mutate]);

  return {
    onPrintWarehouseTransfer: handlePrintWarehouseTransfer,
    onPrintOrder: handlePrintOrder,
  };
};

export default usePreviewPdf;
